import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchPredesTransactionsEdit from '../../api/PredesTransactionsEditAPI';
import { PREDES_TRANSACTIONS_EDIT_REQUEST } from '../actions/types/PredesTransactionsEditActionTypes';
import { putPredesTransactionsEditSuccessActionCreator, putPredesTransactionsEditFailureActionCreator } from '../actions/PredesTransactionsEditActions';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';

function* doPredesTransactionsEditWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchPredesTransactionsEdit, action.payload);
    yield put(putPredesTransactionsEditSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.predes.edit.success'),
    }));
  } catch (error) {
    yield put(putPredesTransactionsEditFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doPredesTransactionsEditWatcher() {
  yield takeLatest(PREDES_TRANSACTIONS_EDIT_REQUEST, doPredesTransactionsEditWorker);
}

export default doPredesTransactionsEditWatcher;
